import { render, staticRenderFns } from "./DashboardsList.vue?vue&type=template&id=405a9b50&"
import script from "./DashboardsList.vue?vue&type=script&lang=js&"
export * from "./DashboardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports